import { useCallback } from 'react'
import { fetchSegments, saveSegments } from '../adminApi'
import { useServerDraft } from '../../hooks/useServerDraft'
import type { SegmentDefinition, SegmentList } from '../../core/types/mail'

/** Het aantal telt de server; dat hoort niet in het concept. */
const toDraft = (list: SegmentList): SegmentDefinition[] => list.items.map(({ count: _c, ...s }) => s)
const persist = (items: SegmentDefinition[], list: SegmentList) => saveSegments({ revision: list.revision, items })

/** Doelgroepen: laden, lokaal samenstellen en in één keer opslaan (PUT /admin/segments). */
export function useSegments() {
  const s = useServerDraft({
    load: fetchSegments,
    toDraft,
    persist,
    savedTitle: 'Doelgroepen opgeslagen',
    savedText: 'De aantallen zijn bijgewerkt.',
    conflictSubject: 'De doelgroepen',
  })
  const list = s.data

  /** Het aantal zoals de server het laatst telde; voor een nieuwe of gewijzigde groep `null` (pas na opslaan). */
  const countOf = useCallback(
    (seg: SegmentDefinition) => {
      const known = list?.items.find((x) => x.id === seg.id)
      return known && JSON.stringify(known.rules) === JSON.stringify(seg.rules) ? known.count : null
    },
    [list],
  )

  return { list, items: s.current ?? [], status: s.status, reload: s.reload, dirty: s.dirty, saving: s.saving, edit: s.edit, save: s.save, discard: s.discard, countOf }
}

export type SegmentsState = ReturnType<typeof useSegments>
